﻿import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/umbraco')({
    component: RouteComponent,
});

function RouteComponent() {
    useEffect(() => {
        window.location.href = window.env.UMBRACO_CMS_BASE_URL + '/umbraco';
    }, []);

    return <div></div>;
}
